import isNil from 'lodash/isNil';

export default function zipCodeMask(value) {
    if (isNil(value) || value.length <= 5) {
        return [/\d/, /\d/, /\d/, /\d/, /\d/];
    }

    return [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
}
